import initSlider from '../sliders/initSlider';
import { thumbsSliderOptions, accountInfoSliderOptions, assetInfoSliderOptions } from '../sliders/sliders';

import initSimpleParallax from '../parallax/initSimpleParallax';
import { parallaxDividerOptions, parallaxHorizontalOptions, parallaxVerticalOptions } from '../parallax/parallax';

import initAccordion from '../initAccordion';

document.addEventListener('DOMContentLoaded', (e) => {
  initAccordion();

  const introSliderSwitchers = document.querySelectorAll('[data-binded-slide]');

  initSlider('[data-intro-slider]', {
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 10000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    on: {
      init: (swiper) => {
        changeActiveSlideSwitcher(introSliderSwitchers, swiper.realIndex);

        introSliderSwitchers.forEach((switcher) => {
          switcher.addEventListener('click', (e) => {
            const slideIndex = switcher.dataset.bindedSlide;
            changeActiveSlideSwitcher(introSliderSwitchers, slideIndex);
            switchSlideByIndex(swiper, slideIndex);
          });
        });
      },
      slideChangeTransitionStart: (swiper) => changeActiveSlideSwitcher(introSliderSwitchers, swiper.realIndex),
    },
  });

  /*  */

  const accountTypeSlider = initSlider('[data-account-type-slider]', thumbsSliderOptions);
  const assetTypeSlider = initSlider('[data-asset-type-slider]', thumbsSliderOptions);
  const accountInfoSlider = initSlider('[data-account-info-slider]', accountInfoSliderOptions);
  const assetInfoSlider = initSlider('[data-asset-info-slider]', assetInfoSliderOptions);

  /*  */

  const parallaxDivider = document.querySelector('[data-parallax-divider]');
  const parallaxHorizontalCards = document.querySelectorAll('[data-parallax-horizontal-card]');
  const parallaxVerticalCards = document.querySelectorAll('[data-parallax-vertical-card]');

  initSimpleParallax(parallaxDivider, parallaxDividerOptions);
  initSimpleParallax(parallaxHorizontalCards, parallaxHorizontalOptions);
  initSimpleParallax(parallaxVerticalCards, parallaxVerticalOptions);
});

const switchSlideByIndex = (slider, index) => slider.slideToLoop(index);

const changeActiveSlideSwitcher = (switchers, index) => {
  switchers.forEach((switcher) => {
    switcher.dataset.bindedSlide == index ? switcher.classList.add('is_active') : switcher.classList.remove('is_active');
  });
};
